"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
function toBackground({ isSelected = false }) {
    return isSelected ? style_1.default.Color.Blue.S100 : style_1.default.Color.Gray.S100;
}
function toColor({ isSelected = false, theme }) {
    return isSelected ? theme.Color.Layout.Lightest : 'auto';
}
function toBorderColor({ isSelected = false }) {
    return isSelected ? style_1.default.Color.Blue.S300 : 'auto';
}
function toHoverBackground({ isSelected = false }) {
    return isSelected ? 'auto' : style_1.default.Color.Gray.S300;
}
exports.NumberContainer = styled_components_1.default.div `
  ${style_1.default.Design.Definition.Bounding};
  ${style_1.default.Text.Definition.Subtitle};
  align-items: center;
  background: ${toBackground};
  color: ${toColor};
  border-color: ${toBorderColor};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;

  &:hover {
    background: ${toHoverBackground};
  }
`;
